import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  ClockIconComponent,
  HoldIconComponent,
  WarningIconComponent,
} from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { SlaDirective } from '../../directives/sla/sla.directive';

/**
 * A task's SLA in one table cell: the due date on top, the remaining time under it.
 * Without a due date a grey "No SLA" placeholder takes the first line.
 * A finished task shows when it finished instead, flagged when that was past the due date.
 */
@Component({
  selector: 'lib-sla-summary-cell',
  templateUrl: './sla-summary-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    SlaDirective,
    ClockIconComponent,
    HoldIconComponent,
    WarningIconComponent,
    TranslocoPipe,
  ],
})
export class SlaSummaryCellComponent {
  readonly dueDate = input<string | null>();
  readonly remaining = input<string | null>();
  /** On-hold tasks show the pause icon instead of the clock. */
  readonly onHold = input(false);
  /** Prefixes the due date with "ETA:", as the completion date columns do. */
  readonly eta = input(false);
  readonly finished = input(false);
  readonly finishedAt = input<string | null>();

  protected readonly finishedLate = computed(() => {
    const finishedAt = this.finishedAt();
    const dueDate = this.dueDate();
    return !!finishedAt && !!dueDate && finishedAt > dueDate;
  });
}
